module.exports = __webpack_public_path__ + "static/img/0.29463b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/0.png
// module id = v7xU
// module chunks = 0